import {observable, action, runInAction} from 'mobx'
import {PAGE_SIZE_DEFAULT} from '../constants/appConstant'
import intelligentOutboundCallAPI from '../apis/intelligentOutboundCallAPI'
import alertMessage from '../utils/alertMessage'

export default class IntelligentOutboundCallStore {
  constructor(rootStore) {
    this.rootStore = rootStore
  }

  @observable isFetching = false
  @observable isGroupFetching = false
  @observable pageSize = PAGE_SIZE_DEFAULT
  @observable pageNo = 1
  @observable currIndex = 0
  @observable itemCount = 0
  @observable pageSizeLog = PAGE_SIZE_DEFAULT
  @observable pageNoLog = 1
  @observable currIndexLog = 0
  @observable inBoundNameList = []
  @observable groupLogData = []
  @observable groupLogTotal = 0
  @observable groupLogPageSize = PAGE_SIZE_DEFAULT
  @observable groupLogPageNo = 1

  /*SearchResult start*/
  @observable searchItem = {
    'marketGroupId': '',
    "taskName": '',
    "taskStatus": '',
    'isPowerUser': false,
    'page': this.pageNo,
    'size': this.pageSize,
  }
  @observable jobList = []

  @action
  async onSearchJobAction(params) {
    this.isFetching = true
    this.jobList = []
    this.pageNo = params.page
    this.pageSize = params.size
    this.itemCount = 0
    try {
      const response = await intelligentOutboundCallAPI.searchAction(params)
      runInAction(() => {
        this.isFetching = false
        if (response.data.code === 0) {
          this.jobList = response.data.data?.records || []
          this.itemCount = response.data.data?.total
          this.searchItem = params
        }
      })
    } catch (err) {
      alertMessage.error('处理异常！'+err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  @observable auditLogsUserList = []
  @action
  async getAuditUsers() {
    this.auditLogsUserList = []
    try {
      const response = await intelligentOutboundCallAPI.getAuditUsers()
      const {code, data, messageEn} = response?.data

      runInAction(() => {
        if (code === 0) {
          this.auditLogsUserList = data?.map(a=>{return {
            ...a,
            "email": a?.email,
            "phone": a?.phone,
            "userId": a?.id,
            "userName": a?.shortName
          }})
        } else {
          alertMessage.error('获取失败' + messageEn + '')
        }
      })
      return response?.data
    } catch (err) {
      alertMessage.error('处理异常！'+err.message)
      runInAction(() => {
      })
    }
  }
  //Status 下拉列表
  @observable statusList = []
  @observable taskList = []
  @observable timeSlotsList = []
  @action
  async onGetStatus(params) {
    if(params==='TimeSlots') {
      this.timeSlotsList = []
    } else if(params==='AiApproveStatus') {
      this.statusList = []
    } else {
      this.taskList = []
    }
    try {
      const response = await intelligentOutboundCallAPI.getStatus(params)
      const {code, data, messageEn} = response?.data

      runInAction(() => {
        if (code === 0) {
          if(params==='TimeSlots') {
            this.timeSlotsList = JSON.parse(JSON.stringify(data))
          } else if(params==='AiApproveStatus') {
            this.statusList = JSON.parse(JSON.stringify(data))
          } else {
            this.taskList = JSON.parse(JSON.stringify(data))
          }
        } else {
          alertMessage.error('失败！' + messageEn + '')
        }
      })
      return response?.data
    } catch (err) {
      alertMessage.error('处理异常！'+err.message)
      runInAction(() => {
      })
    }
  }

  @action
  onChangeJob(value) {
    this.jobList = value
    this.itemCount = 0
  }

  /*SearchResult end*/

  /*get edit*/
  @observable detailsObj = null

  @action
  async onGetJobAction(params) {
    this.isFetching = true
    try {
      const response = await intelligentOutboundCallAPI.getAction(params)
      runInAction(() => {
        this.isFetching = false
        const {data} = response.data
        if (response.data.code === 0) {
          this.detailsObj = data || null
        }
      })
      return response.data.data
    } catch (err) {
      alertMessage.error('处理异常！'+err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }


  /*status*/
  @action
  async onChangeStatus(apiID) {
    this.isFetching = true
    try {
      const response = await intelligentOutboundCallAPI.statusAction(apiID)
      runInAction(() => {
        this.isFetching = false
        // if (response.data.code === 200) {
        if (response.data.code === 0) {
          alertMessage.success('获取成功！')
          this.onSearchJobAction({
            ...this.searchItem,
            'page': 1,
            'size': PAGE_SIZE_DEFAULT,
          })
        } else {
          alertMessage.error('获取失败！' + response.data.data + '')
        }
      })
    } catch (err) {
      alertMessage.error('处理异常！'+err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  /*delete*/
  @action
  async onDeleteJobAction(params) {
    this.isFetching = true
    try {
      const response = await intelligentOutboundCallAPI.deleteAction(params)
      runInAction(() => {
        this.isFetching = false
        if (response.data.code === 0) {
          alertMessage.success('删除成功！')
          this.onSearchJobAction({
            ...this.searchItem,
            'page': 1,
            'size': PAGE_SIZE_DEFAULT,
          })
        } else {
          alertMessage.error('删除失败！' + response.data.messageEn + '')
        }
      })
    } catch (err) {
      alertMessage.error('处理异常！'+err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }
  /*close*/
  @action
  async onCloseJobAction(params) {
    this.isFetching = true
    try {
      const response = await intelligentOutboundCallAPI.closeAction(params)
      runInAction(() => {
        this.isFetching = false
        if (response.data.code === 0) {
          alertMessage.success('删除成功！')
          this.onSearchJobAction({
            ...this.searchItem,
            'page': 1,
            'size': PAGE_SIZE_DEFAULT,
          })
        } else {
          alertMessage.error('删除失败！' + response.data.messageEn + '')
        }
      })
    } catch (err) {
      alertMessage.error('处理异常！'+err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }
  /*pause*/
  @action
  async onPauseAction(params) {
    this.isFetching = true
    try {
      const response = await intelligentOutboundCallAPI.pauseAction(params)
      runInAction(() => {
        this.isFetching = false
        if (response.data.code === 0) {
          alertMessage.success('操作成功！')
          this.onSearchJobAction({
            ...this.searchItem,
            'page': 1,
            'size': PAGE_SIZE_DEFAULT,
          })
        } else {
          alertMessage.error('操作失败！' + response.data.messageEn + '')
        }
      })
    } catch (err) {
      alertMessage.error('处理异常！'+err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  /*retry*/
  @action
  async onRetryAction(params) {
    this.isFetching = true
    try {
      const response = await intelligentOutboundCallAPI.retryAction(params)
      runInAction(() => {
        this.isFetching = false
        if (response.data.code === 0) {
          alertMessage.success('操作成功！')
          this.onSearchJobAction({
            ...this.searchItem,
            'page': 1,
            'size': PAGE_SIZE_DEFAULT,
          })
        } else {
          alertMessage.error('操作失败！' + response.data.messageEn + '')
        }
      })
    } catch (err) {
      alertMessage.error('处理异常！'+err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  @action
  onChangePageNumAction(pageNo, pageSize) {
    if (this.pageNo === pageNo && (!pageSize || this.pageSize === pageSize)) {
      return
    }
    runInAction(() => {
      this.pageNo = pageNo
      this.pageSize = pageSize
    })
    this.onSearchJobAction({
      'marketGroupId': this.searchItem.marketGroupId,
      "taskName": this.searchItem.taskName,
      "taskStatus": this.searchItem.taskStatus,
      'isPowerUser': this.searchItem.isPowerUser,
      'page': pageNo,
      'size': pageSize,
    })
  }

  @action
  async groupLogSave(params) {
    this.isGroupFetching = true
    try {
      const response = await intelligentOutboundCallAPI.groupLogSave(params)
      runInAction(() => {
        this.isGroupFetching = false
        if (response.data.code === 0) {
          alertMessage.success('保存成功！')
        } else {
          alertMessage.error('保存失败！' + response.data.message + '')
        }
      })
      return response.data
    } catch (err) {
      alertMessage.error('处理异常！'+err.message)
      runInAction(() => {
        this.isGroupFetching = false
      })
    }
  }

  @action
  async groupLogList(params) {
    this.isGroupFetching = true
    try {
      const response = await intelligentOutboundCallAPI.groupLogList(params)
      runInAction(() => {
        this.isGroupFetching = false
        if (response.data.code === 0) {
          this.groupLogTotal = response.data.data.total
          this.groupLogData = response.data.data.records
        } else {
        }
      })
      return response.data
    } catch (err) {
      alertMessage.error('处理异常！'+err.message)
      runInAction(() => {
        this.isGroupFetching = false
      })
    }
  }

  @action
  async groupLogPageNumAction(pageNo, pageSize, params) {
    if (this.groupLogPageNo === pageNo && (!pageSize || this.groupLogPageSize === pageSize)) {
      return
    }
    runInAction(() => {
      this.groupLogPageNo = pageNo
      this.groupLogPageSize = pageSize
    })
    this.groupLogList({
      ...params,
      'page': pageNo,
      'size': pageSize,
    }).then()
  }

  
    
    //展会届次列表
    @observable customWorkday = [{
      id: 1,
      name: '星期一',
    }, {
      id: 2,
      name: '星期二',
    }, {
      id: 3,
      name: '星期三',
    }, {
      id: 4,
      name: '星期四',
    }, {
      id: 5,
      name: '星期五',
    }, {
      id: 6,
      name: '星期六',
    }, {
      id: 0,
      name: '星期日',
    }]
    @action
    async onExpoAction(params) {
      this.expoList = []
      try {
        const response = await intelligentOutboundCallAPI.expoAction(params)
        runInAction(() => {
          if (response.data.code === 0) {
            this.expoList = response.data.data
          } else {
            alertMessage.error('重新发送失败！' + response.data.messageEn + '')
          }
        })
        return response
      } catch (err) {
        alertMessage.error('处理异常！'+err.message)
        runInAction(() => {
        })
      }
    }
    @observable isFetchingPhone = false
    /* 获取手机号统计结果 */
    @observable handPhoneNum = 0
    @observable validHandPhoneNum = 0
    @observable invalidHandPhoneNum = 0
    @observable filePhoneNum = 0
    @observable validFilePhoneNum = 0
    @observable invalidFilePhoneNum = 0
    @observable resourcePhoneNum = 0
    @observable validResourcePhoneNum = 0
    @observable invalidResourcePhoneNum = 0
    @observable pageSizePhone = PAGE_SIZE_DEFAULT
    @observable pageNoPhone = 1
    @observable currIndexPhone = 0
    @observable itemCountPhone = 0
    @observable searchItemPhone = {
      'phone': '',
      'isPowerUser' : false,
      'page': this.pageNoPhone,
      'size': this.pageSizePhone,
    }
    @observable phoneList = []
    @observable handPhoneList = []
    @observable filePhoneList = []
    @observable resourcePhoneList = []
    @observable phoneTable = []
    @action
    async onPhoneAction(params) {
      this.isFetchingPhone = true
      this.pageNoPhone = params.page
      this.pageSizePhone = params.size
      this.itemCountPhone = 0
      this.phoneList = []
      try {
        const response = await intelligentOutboundCallAPI.phoneAction(params)
        runInAction(() => {
          this.isFetchingPhone = false
          if (response.data.code === 0) {
            this.phoneList = response.data.data?.records || []
            this.itemCountPhone = response.data.data?.total
            this.searchItemPhone = params
          }
        })
        return response
      } catch (err) {
        alertMessage.error('处理异常！'+err.message)
        runInAction(() => {
          this.isFetchingPhone = false
        })
      }
    }
    @action
    onChangePhonePageNumAction(pageNo, pageSize) {
      if (this.pageNoPhone === pageNo && (!pageSize || this.pageSizePhone === pageSize)) {
        return
      }
      runInAction(() => {
        this.pageNoPhone = pageNo
        this.pageSizePhone = pageSize
      })
      this.onPhoneAction({
        ...this.searchItemPhone,
        'page': pageNo,
        'size': pageSize,
      })
    }
    @action
    async onStatisticsAction(params) {
      this.isFetchingPhone = true
      try {
        const response = await intelligentOutboundCallAPI.statisticsAction(params)
        runInAction(() => {
          this.isFetchingPhone = false
          if (response.data.code === 0) {
            this.handPhoneNum = response.data.data?.manualNumberTotal || 0
            this.validHandPhoneNum = response.data.data?.manualNumberValid || 0
            this.invalidHandPhoneNum = response.data.data?.manualNumberInvalid || 0
            this.filePhoneNum = response.data.data?.templateImportNumberTotal || 0
            this.validFilePhoneNum = response.data.data?.templateImportNumberValid || 0
            this.invalidFilePhoneNum = response.data.data?.templateImportNumberInvalid || 0
            this.resourcePhoneNum = response.data.data?.resourcePoolImportNumberTotal || 0
            this.validResourcePhoneNum = response.data.data?.resourcePoolImportNumberValid || 0
            this.invalidResourcePhoneNum = response.data.data?.resourcePoolImportNumberInvalid || 0
          }
        })
        return response
      } catch (err) {
        alertMessage.error('处理异常！'+err.message)
        runInAction(() => {
          this.isFetchingPhone = false
        })
      }
    }
    @action
    onChangeHandPhoneNum(value){
      this.handPhoneNum = value
    }
    @action
    onChangeFilePhoneNum(value){
      this.filePhoneNum = value
    }
    @action
    onChangeResourcePhoneNum(value){
      this.resourcePhoneNum = value
    }
    @action
    onChangeAllNum(value){
      this.allNum = value
    }
    // phone
    // phone
    // phone
    /* 添加号码 */
    @action
    async onAddPhoneAction(params) {
      this.isFetchingPhone = true
      try {
        const response = await intelligentOutboundCallAPI.addPhoneAction(params)
        runInAction(() => {
          this.isFetchingPhone = false
          if (response.data.code === 0) {
            alertMessage.success('添加成功！')
          } else {
            alertMessage.error('添加失败！' + response.data.messageEn + '')
          }
        })
        return response
      } catch (err) {
        alertMessage.error('处理异常！'+err.message)
        runInAction(() => {
          this.isFetchingPhone = false
        })
      }
    }
    /* 添加号码 */
    @action
    async onAddPoolPhoneAction(params) {
      this.isFetchingPhone = true
      try {
        const response = await intelligentOutboundCallAPI.addPoolPhoneAction(params)
        runInAction(() => {
          this.isFetchingPhone = false
          if (response.data.code === 0) {
            alertMessage.success('添加成功！')
          } else {
            alertMessage.error('添加失败！' + response.data.messageEn + '')
          }
        })
        return response
      } catch (err) {
        alertMessage.error('处理异常！'+err.message)
        runInAction(() => {
          this.isFetchingPhone = false
        })
      }
    }
    /* 删除所有号码 */
    @action
    async onDeletePhoneAction(params) {
      this.isFetchingPhone = true
      try {
        const response = await intelligentOutboundCallAPI.deletePhoneAction(params)
        runInAction(() => {
          this.isFetchingPhone = false
          if (response.data.code === 0) {
            alertMessage.success('清理成功！')
            this.onPhoneAction(this.searchItemPhone)
          } else {
            alertMessage.error('清理失败！' + response.data.messageEn + '')
          }
        })
        return response
      } catch (err) {
        alertMessage.error('处理异常！'+err.message)
        runInAction(() => {
          this.isFetchingPhone = false
        })
      }
    }
    /* 删除某条号码 */
    @action
    async onDeleteOnePhoneAction(params) {
      this.isFetchingPhone = true
      try {
        const response = await intelligentOutboundCallAPI.deleteOnePhoneAction(params)
        runInAction(() => {
          this.isFetchingPhone = false
          if (response.data.code === 0) {
            alertMessage.success('清理成功！')
            this.onPhoneAction(this.searchItemPhone)
          } else {
            alertMessage.error('清理失败！' + response.data.messageEn + '')
          }
        })
        return response
      } catch (err) {
        alertMessage.error('处理异常！'+err.message)
        runInAction(() => {
          this.isFetchingPhone = false
        })
      }
    }
    /* 清空号码 */
    @action
    async onClearPhoneAction(params) {
      this.isFetchingPhone = true
      try {
        const response = await intelligentOutboundCallAPI.clearPhoneAction(params)
        runInAction(() => {
          this.isFetchingPhone = false
          if (response.data.code === 0) {
            this.handPhoneNum = 0
            this.validHandPhoneNum = 0
            this.invalidHandPhoneNum = 0
            this.filePhoneNum = 0
            this.validFilePhoneNum = 0
            this.invalidFilePhoneNum = 0
            this.resourcePhoneNum = 0
            this.validResourcePhoneNum = 0
            this.invalidResourcePhoneNum = 0
            alertMessage.success('清理成功！')
            this.searchItemPhone = {
              ...this.searchItemPhone,
              ...params,
            }
          } else {
            alertMessage.error('清理失败！' + response.data.messageEn + '')
          }
        })
        return response
      } catch (err) {
        alertMessage.error('处理异常！'+err.message)
        runInAction(() => {
          this.isFetchingPhone = false
        })
      }
    }
    // 场景模型列表
    @observable modelList = []
    @action
    async onGetModelList(params) {
      this.modelList = []
      try {
        const response = await intelligentOutboundCallAPI.modelList(params)
        const {code, data, messageEn} = response?.data

        runInAction(() => {
          if (code === 0) {
            this.modelList = data
          } else {
            alertMessage.error('获取失败' + messageEn + '')
          }
        })
        return response?.data
      } catch (err) {
        alertMessage.error('处理异常！'+err.message)
        runInAction(() => {
        })
      }
    }
    // 主叫号码列表
    @observable callerList = []
    @action
    async onGetCallerList(params) {
      this.callerList = []
      try {
        const response = await intelligentOutboundCallAPI.callerList(params)
        const {code, data, messageEn} = response?.data

        runInAction(() => {
          if (code === 0) {
            this.callerList = data
          } else {
            alertMessage.error('获取失败' + messageEn + '')
          }
        })
        return response?.data
      } catch (err) {
        alertMessage.error('处理异常！'+err.message)
        runInAction(() => {
        })
      }
    }

    //获取资源池的 下拉列表
    @observable resourcePoolList = []
    @action
    async onGetResourcePool(params) {
      this.resourcePoolList = []
      try {
        const response = await intelligentOutboundCallAPI.getResourcePool(params)
        const {code, data, messageEn} = response?.data
        runInAction(() => {
          if (code === 0) {
            this.resourcePoolList = data?.filter(a=>a?.status===0)
          } else {
            alertMessage.error('获取资源池失败' + messageEn + '')
          }
        })
        return response?.data
      } catch (err) {
        alertMessage.error('处理异常！'+err.message)
        runInAction(() => {
        })
      }
    }
    /*add */
    @action
    async onAddAction(params, title) {
      this.isFetching = true
      try {
        const response = await intelligentOutboundCallAPI.addAction(params)
        runInAction(() => {
          this.isFetching = false
          if (response.data?.code === 0) {
            this.handPhoneNum = 0
            this.validHandPhoneNum = 0
            this.invalidHandPhoneNum = 0
            this.filePhoneNum = 0
            this.validFilePhoneNum = 0
            this.invalidFilePhoneNum = 0
            this.resourcePhoneNum = 0
            this.validResourcePhoneNum = 0
            this.invalidResourcePhoneNum = 0
            alertMessage.success(title === 'edit' ? '编辑成功！' : '添加成功！')
            this.onSearchJobAction(this.searchItem)
          } else {
            alertMessage.error(title === 'edit' ? '编辑失败！' + response.data?.messageEn : '添加失败！' + response.data?.messageEn)
          }
        })
        return response
      } catch (err) {
        alertMessage.error('处理异常！'+err.message)
        runInAction(() => {
          this.isFetching = false
        })
      }
    }
    
  @observable isTestSendFetching = false
  // 短信测试接口
  @action
  async onSendTestPhone(params) {
    this.isTestSendFetching = true;
    try {
      const response = await intelligentOutboundCallAPI.sendTestPhone(params)
      const { code, data, messageEn } = response?.data

      runInAction(() => {
        this.isTestSendFetching = false;
        if (code === 0) {
          alertMessage.success('呼叫成功')
        } else {
          alertMessage.error('呼叫失败！' + messageEn + '')
        }
      })
      return response?.data
    } catch (err) {
      alertMessage.error('处理异常！' + err.message)
      runInAction(() => {
        this.isTestSendFetching = false;
      })
    }
  }
    /*agree*/
    @action
    async onAgreeAction(params) {
      this.isFetching = true
      try {
        const response = await intelligentOutboundCallAPI.agreeAction(params)
        runInAction(() => {
          this.isFetching = false
          if (response.data.code === 0) {
            alertMessage.success(params?.approveResult ==='3' ? '审批成功！' : '拒绝成功！')
            this.onSearchJobAction({
              ...this.searchItem,
              'page': 1,
              'size': PAGE_SIZE_DEFAULT,
            })
          } else {
            alertMessage.error(params?.approveResult ==='3' ? '审批失败！' + response.data.messageEn + '' : '拒绝失败！' + response.data.messageEn + '')
          }
        })
        return response
      } catch (err) {
        alertMessage.error('处理异常！'+err.message)
        runInAction(() => {
          this.isFetching = false
        })
      }
    }
}
